import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "page.module.css";
import MobileSideBar from "./MobileSideBar";
import { useUser } from "context/UserContext";
import { creditsAPI } from "services/transactionService";
import finalConfig from "configs/config";

const Header = () => {
  const [showSubSidebar, setShowSubSidebar] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, derivedState, userBalance, updateUserBalance } =
    useUser();
  const isLandingPage = location.pathname === "/";
  const isPlansPage = location.pathname === "/plans";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
        setShowSubSidebar(false);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load user balance when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      updateUserBalance();
    }
  }, [isAuthenticated, derivedState, updateUserBalance]);

  const toggleSubSidebar = () => {
    setShowSubSidebar((prevState) => !prevState);
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 3000,
          backgroundColor: "#fbfbfb",
        }}
      >
        <div className="container-fluid d-flex align-items-center">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img
              src="/logo/logo.svg"
              alt="MyApp Logo"
              width={160}
              height={30}
              className="me-3"
            />
          </Link>

          <div className="ms-auto d-flex align-items-center">
            {/* Account Balance Display - Show when authenticated and not on landing page */}
            {isAuthenticated && !isLandingPage && (
              <div className="me-3 d-none d-md-block">
                <div className="card border-0 shadow-sm" style={{ backgroundColor: '#eef0fd', borderRadius: '12px' }}>
                  <div className="card-body px-3 py-2">
                    <div className="d-flex align-items-center">
                      <div className="text-start">
                        <div className="small mb-0" style={{ fontSize: '0.75rem', lineHeight: '1', color: '#5a5c61' }}>
                          Credits Available
                        </div>
                        <div className="fw-bold mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.2', color: '#6e70f3' }}>
                          {userBalance !== null ? `${userBalance}` : "---"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Buttons for Landing Page and Plans Page (only when not authenticated) */}
            {(isLandingPage || (isPlansPage && !isAuthenticated)) && (
              <>
                <Link
                  to="/plans"
                  className="btn btn-outline-primary me-3 d-none d-md-inline-block"
                  style={{
                    borderRadius: "25px",
                    padding: "8px 20px",
                    fontWeight: "500",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#007bff";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#007bff";
                  }}
                >
                  Plans
                </Link>
                <Link
                  to="/signIn"
                  className="btn btn-primary me-3 d-none d-md-inline-block"
                  style={{
                    borderRadius: "25px",
                    padding: "8px 20px",
                    fontWeight: "500",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  Sign In
                </Link>
              </>
            )}

            <div
              className={` ${styles.hover_dark} p-1 d-block d-sm-none rounded`}
              onClick={toggleSubSidebar}
            >
              <img
                src="/hamburger-button.png"
                alt="hamburger-button"
                width={20}
                height={20}
                className="me-3 ms-2"
              />
            </div>
          </div>
        </div>
      </nav>
      {isSmallScreen && (
        <MobileSideBar
          showSubSidebar={showSubSidebar}
          setShowSubSidebar={setShowSubSidebar}
        />
      )}
    </>
  );
};

export default Header;
